export default __webpack_public_path__ + "static/media/6.68c77cc3.png";